import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ConnectBtn = styled(Button)({
  height: "40px",
  lineHeight: "40px",
  maxHeight: "40px",
  color: "#22D758",
  fontSize: 14,
  fontFamily: "Gill Sans",
  textTransform: "uppercase",
  padding: "0 12px",
  background: "rgba(34, 215, 88, 0.2)",
  border: "none",
  borderRadius: "4px",
  ".downIcon": {
    marginLeft: "10px",
  },
  "&:hover": {
    background: "#22D758",
    color: "#000000",
    ".downIcon": {
      path: {
        fill: "#000000",
        stroke: "#000000",
      },
    },
  },
});
